// extracted by mini-css-extract-plugin
export default {"search":"Search_search__4c9EZ","input":"Search_input__IOJKB","icon":"Search_icon__PVZRf"};